/**
 * Título de página con estilo banner: fondo lime verde, texto verde oscuro, forma pill
 */
function PageTitle({ children, className = '' }) {
  return (
    <div
      className={`w-[90%] max-w-2xl mx-auto mb-6 py-3 px-6 rounded-[2rem] bg-[#CEF630] text-[#0f3c32] font-semibold text-xl text-center shadow-lg ${className}`}
    >
      {children}
    </div>
  );
}

export default PageTitle;
